import { template as template_352d5fdded6446648a87dc5f35c8c924 } from "@ember/template-compiler";
import LayerArrangement from 'eflex/components/inputs/layer-arrangement';
import LockObject from 'eflex/components/inputs/lock-object';
import DynamicObjectToggle from 'eflex/components/work-instruction-editor/tool-properties/dynamic-object-toggle';
import UrlHyperlinkToggle from 'eflex/components/work-instruction-editor/tool-properties/url-hyperlink-toggle';
import BsButton from 'eflex/components/bs-button';
import BsTooltip from 'eflex/components/bs-tooltip';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { or, not, and } from 'ember-truth-helpers';
import { t } from 'ember-intl';
export default template_352d5fdded6446648a87dc5f35c8c924(`
<div class="eflex-scroll p-3 pb-5 h-100" ...attributes>
  <div class="row flex-column gy-3 mb-4">
    <div class="col-auto">
      <div class="row align-items-center gx-2">
        <div class="col">
          <span class="title fw-bold lh-sm">
            {{@title}}
          </span>
        </div>
        <div class="col-auto">
          <LayerArrangement
            @disabled={{or @locked @actionsDisabled (not @canvasObjectSelected) @arrangeDisabled}}
          />
        </div>
        <div class="col-auto">
          <LockObject
            @disabled={{or @actionsDisabled (not @canvasObjectSelected)}}
            @locked={{@locked}}
            @onChange={{@onLockChange}}
          />
        </div>
        <div class="col-auto">
          <BsButton
            @type="peripheral"
            @disabled={{or @locked @actionsDisabled (not @canvasObjectSelected)}}
            @onClick={{@deleteSelectedObject}}
            class="delete-object-button border-0 transition-none d-flex"
          >
            <FaIcon @icon="trash" @prefix="fas" class="fa-fw" />
            <BsTooltip @title="{{t "delete"}} — Del" @delayShow={{600}} />
          </BsButton>
        </div>
      </div>
      {{#if @onMakeDefault}}
        <BsButton
          class="make-default-button text-truncate fs-4 p-0"
          @type="link"
          @onClick={{@onMakeDefault}}
        >
          {{t "imageEditor.makeDefault"}}
        </BsButton>
      {{/if}}
    </div>
  </div>

  {{yield}}

  {{#if (and @updateObjectName @updateStartHidden)}}
    <hr class="my-4" />
    <DynamicObjectToggle
      @dynamicObjectName={{@dynamicObjectName}}
      @startHidden={{@startHidden}}
      @updateObjectName={{@updateObjectName}}
      @updateStartHidden={{@updateStartHidden}}
      @disabled={{@locked}}
    />
  {{/if}}

  {{#if @updateLink}}
    <hr class="my-4" />
    <UrlHyperlinkToggle
      @link={{@link}}
      @updateLink={{@updateLink}}
      @disabled={{@locked}}
    />
  {{/if}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
